import { Avatar } from 'antd'
import React, { useMemo } from 'react'
import { getColorByLetter } from '../common/helpers';
import dayjs from 'dayjs';
import { DATE_FORMAT_DD_MM_YYYY_HH_mm_A } from '../constants/constants';
import DotIcon from './icons/DotIcon';
import NotificationIcon from './icons/NotificationIcon';

interface Props {
    data: any
    onClick: () => void;
}
const NotificationListItem = (props: Props) => {
    const { data } = props;


    return (
        <div className='p-[10px] hover:bg-[#ECFDF3] rounded-[8px] cursor-pointer' onClick={props.onClick}>
            <div className='flex items-center justify-between gap-x-[12px]'>
                <div className='flex items-center gap-x-[12px]'>
                    <Avatar style={{ backgroundColor: "#F2F4F7" }} icon={<NotificationIcon />} />
                    <p className='text-[12px] font-[500] m-0 flex-1'>{data?.notification}</p>
                </div>
                {!data?.seen ? <DotIcon /> : <></>}
            </div>
            <p className='m-0 text-[#667085] text-[10px] text-end'>{dayjs(data.timestamp).format(DATE_FORMAT_DD_MM_YYYY_HH_mm_A)}</p>
        </div>

    )
}

export default NotificationListItem